import _extends from "@babel/runtime/helpers/esm/extends";
import { reactUIFeatureFlagsDefault } from "../ReactUIFeatureFlagsContext";
export var getFullReactUIFlagsContext = function getFullReactUIFlagsContext(flags) {
  return _extends({}, reactUIFeatureFlagsDefault, flags);
};